var map = {
	"./groupbuypage-location.png": "402f",
	"./groupbuypage-sample.jpg": "00bf",
	"./homepage-location.png": "b705",
	"./homepage-sample.jpg": "624f",
	"./popupbanner-location.png": "f7a7",
	"./popupbanner-sample.png": "9889",
	"./promotion-location.png": "b3a1",
	"./promotion-sample.jpg": "2872",
	"./shoplink-location.png": "d219",
	"./shoplink-sample.gif": "5be9",
	"./shopvideo-location.png": "702e",
	"./specialpricepage-location.png": "cd6d",
	"./specialpricepage-sample.jpg": "df09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0208";